/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Добавить запись в справочник категорий продуктов - второй уровень
 */
export interface AddLoyaltyCategory { 
    /**
     * связь с таблицей LoyaltyCategoryGroups
     */
    loyaltyCategoryGroupId?: string;
    /**
     * Наименование категории.
     */
    name: string;
    /**
     * Описание категории.
     */
    description?: string;
    /**
     * ID фотографии/иконки.
     */
    iconId?: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
}

